/* eslint-disable */

<template>
  <div class="vx-row items-center justify-center">
    <div class="vx-col w-full justify-center flex flex-col items-center">
      <div class="image-wrapper">
        <img src="https://ip-learn.b-cdn.net/simulations/ai-controls/graphics.png" class="responsive-image" />

        <v-select
          v-for="(field, index) in overlayFields"
          :key="field.id"
          :options="options"
          v-model="field.value"
          class="overlay-select"
          placeholder="Select"
          :ref="(el) => (fieldRefs[index] = el)"
          :style="{ top: field.top, left: field.left, width: field.width, zIndex: 999 - index }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      fieldRefs: [],

      overlayFields: [
        { id: 'input0', group: 0, top: '10%', left: '37%', width: '275px', value: '', answers: ['IAM policies', 'Resource policies'] },
        { id: 'input1', group: 0, top: '10%', left: '63.5%', width: '275px', value: '', answers: ['Resource policies', 'IAM policies'] },

        {
          id: 'input2',
          group: 1,
          top: '82%',
          left: '16.2%',
          width: '200px',
          value: '',
          answers: ['Threat protection', 'Injection policies'],
        },
        {
          id: 'input3',
          group: 1,
          top: '89%',
          left: '16.2%',
          width: '200px',
          value: '',
          answers: ['Injection policies', 'Threat protection'],
        },

        {
          id: 'input4',
          group: 2,
          top: '29%',
          left: '33.5%',
          width: '225px',
          value: '',
          answers: ['Authentication token validation', 'Connection rate limits'],
        },
        {
          id: 'input5',
          group: 2,
          top: '35.7%',
          left: '33.5%',
          width: '225px',
          value: '',
          answers: ['Connection rate limits', 'Authentication token validation'],
        },

        {
          id: 'input6',
          group: 3,
          top: '82%',
          left: '50.8%',
          width: '200px',
          value: '',
          answers: ['Token input quota', 'Modality limitations'],
        },
        {
          id: 'input7',
          group: 3,
          top: '89%',
          left: '50.8%',
          width: '200px',
          value: '',
          answers: ['Modality limitations', 'Token input quota'],
        },

        { id: 'input8', group: 4, top: '82%', left: '79.3%', width: '200px', value: '', answers: ['Input token validation', 'Guardrails'] },
        { id: 'input9', group: 4, top: '89%', left: '79.3%', width: '200px', value: '', answers: ['Guardrails', 'Input token validation'] },
      ],

      options: [
        'Injection policies',
        'Resource policies',
        'Connection rate limits',
        'Input token validation',
        'Threat protection',
        'Token input quota',
        'Modality limitations',
        'IAM policies',
        'Authentication token validation',
        'Guardrails',
      ],
    };
  },

  methods: {
    markSimulation() {
      let totalScore = 0;

      // Track used answers PER GROUP (pair)
      const usedAnswersByGroup = {};

      this.overlayFields.forEach((field, index) => {
        field.isCorrect = null;

        if (!field.value) return;

        // ✅ Check if selected value is one of the allowed answers
        const isCorrect = field.answers.includes(field.value);

        // Initialize group tracking if needed
        if (!usedAnswersByGroup[field.group]) {
          usedAnswersByGroup[field.group] = new Set();
        }

        // Check duplicate within same pair
        const isDuplicate = usedAnswersByGroup[field.group].has(field.value);

        if (isCorrect && !isDuplicate) {
          field.isCorrect = true;
          usedAnswersByGroup[field.group].add(field.value);
          totalScore++;
        } else {
          field.isCorrect = false;
        }

        // Apply visual feedback
        const selectEl = this.fieldRefs[index]?.$el.querySelector('.vs__dropdown-toggle');
        if (selectEl) {
          selectEl.style.border =
            field.isCorrect === true ? '1px solid #28C76F' : field.isCorrect === false ? '1px solid #EA5455' : '1px solid transparent';
        }
      });

      // Emit results
      if (totalScore === this.overlayFields.length) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },

  components: {
    vSelect,
    Prism,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  width: 100%;
  max-width: 1250px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.overlay-select {
  position: absolute;
  transform: translate(-50%, -50%);
}

.overlay-select ::v-deep(.vs__dropdown-toggle) {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

.overlay-select ::v-deep(.vs__selected) {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overlay-select ::v-deep(.vs__selected-options) {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

.overlay-select ::v-deep(.vs__search::placeholder) {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.overlay-select ::v-deep(.vs--has-value .vs__search) {
  flex: 0 0 0;
  width: 0;
  padding: 0;
}
</style>
